import { useEffect } from "react";
import Highcharts from "highcharts";
import { OptionsSpiderwebSeries } from "store/slice/charts";

const useCustomiseLabelsSpiderwebs = (
    showRoles: boolean,
    showNames: boolean,
    setChartOptions:
        | React.Dispatch<React.SetStateAction<Highcharts.Options>>
        | React.Dispatch<React.SetStateAction<OptionsSpiderwebSeries>>,
    legendSelected: number[]
): void => {
    useEffect(() => {
        setChartOptions((options: OptionsSpiderwebSeries | Highcharts.Options) => {
            const { series, ...restOptions } = options;

            const newSeries =
                series && //@ts-ignore
                series.map(({ data, ...restSerieOptions }) => {
                    return {
                        data,
                        ...restSerieOptions,
                        ...(restSerieOptions?.custom?.entity_type === "person"
                            ? {
                                  name:
                                      showRoles && showNames
                                          ? `${restSerieOptions?.custom?.entity_name ?? restSerieOptions?.name} </br> ${
                                                restSerieOptions?.custom?.label ?? ""
                                            }`
                                          : showRoles
                                          ? restSerieOptions?.custom?.label ?? ""
                                          : showNames
                                          ? restSerieOptions?.custom?.entity_name ?? restSerieOptions?.name
                                          : restSerieOptions?.custom?.label ?? "",
                              }
                            : {}),
                    };
                });

            return { ...restOptions, series: newSeries };
        });
    }, [showRoles, showNames, setChartOptions, legendSelected]);
};

export default useCustomiseLabelsSpiderwebs;
